import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import isValid from 'date-fns/isValid';
import isDate from 'date-fns/isDate';

const ISO_WITHOUT_TZ = "yyyy-MM-dd'T'HH:mm:ss";

export const getIsoDateWithoutTz = (date: Date): string => {
  return format(date, ISO_WITHOUT_TZ);
};

export const parseIsoDateWithoutTz = (date: string): Date => parseISO(date.replace('Z', ''));

export const checkIfStrDate = (str: string): boolean => {
  const parsedDate = parseISO(str);
  return isValid(parsedDate);
};

export const getDateOfJoining = (dateOfJoin: string | null): string =>
  dateOfJoin ? format(parseIsoDateWithoutTz(dateOfJoin), 'dd MMM yyyy') : 'N/A';

export const getBirthDay = (date: string | null): string =>
  date ? format(parseIsoDateWithoutTz(date), 'MMMM d') : 'Not specified';

export const toLocalDateString = (value: string | null | undefined): string | null => {
  if (!value) return null;
  return value.includes('T') ? value : `${value}T00:00:00`;
};

// Formats date string without timezone conversion by extracting date components
export const formatDateWithoutTimezone = (dateString: string, formatString: string): string => {
  const datePart = dateString.substring(0, 10); // "2026-03-15"
  const [year, month, day] = datePart.split('-');

  const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));

  return format(date, formatString);
};

// Parses ISO date string for DatePicker without timezone conversion
export const parseDateForPicker = (dateValue: string | Date | null | undefined): Date | null => {
  if (!dateValue) return null;

  if (isDate(dateValue)) return dateValue as Date;

  if (typeof dateValue === 'string' && (dateValue.includes('T') || dateValue.includes('-'))) {
    const datePart = dateValue.substring(0, 10); // "2026-03-15"
    const [year, month, day] = datePart.split('-');

    return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
  }

  return dateValue as Date;
};

// Formats Date from DatePicker for saving as UTC midnight ISO string
export const formatDateForSave = (dateValue: unknown): string | unknown => {
  if (isDate(dateValue) && isValid(dateValue)) {
    const date = dateValue as Date;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00.000Z`;
  }
  return dateValue;
};
